import React, { FC, useCallback, useState } from 'react'

import { Grid, Typography } from '@mui/material'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { Modal } from '../../../../components/Modal'
import { Toggle } from '../../../../components/Toggle'
import { InputField } from '../../../../components/InputField'
import { commissionsAdjustResolver } from './resolvers'
import { setAdjustCommissions } from '../../../../store/actions'

interface CommissionsAdjustModalProps {
  isOpen: boolean
  modalClose: () => void
}

export const CommissionsAdjustModal: FC<CommissionsAdjustModalProps> = ({ isOpen, modalClose }) => {
  const dispatch = useDispatch()
  const [checkedPercentage, setCheckedPercentage] = useState<boolean>(true)
  const [checkedAmount, setCheckedAmount] = useState<boolean>(false)

  const formMethods = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    shouldFocusError: true,
    resolver: commissionsAdjustResolver,
  })
  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = formMethods

  const handleCheckToggles = useCallback(() => {
    reset()
    setCheckedPercentage(!checkedPercentage)
    setCheckedAmount(!checkedAmount)
  }, [reset, checkedPercentage, checkedAmount])

  const onSubmit = useCallback(
    (data) => {
      dispatch(setAdjustCommissions({ percentage: data.percentage || null, amount: data.amount || null }))
      reset()
    },
    [dispatch, reset],
  )

  return (
    <Modal
      title="Adjust"
      submitTitle="Ok"
      isOpen={isOpen}
      modalClose={modalClose}
      onSubmit={handleSubmit(onSubmit)}
      isSubmitDisabled={!isValid}
    >
      <FormProvider {...formMethods}>
        <Grid container spacing={2} minHeight={160}>
          <Grid item xs={12} display={'flex'} alignItems={'flex-start'} justifyContent={'space-between'}>
            <Grid item xs={4} padding={1}>
              <Typography component="span">Percentage, %: </Typography>
            </Grid>
            <Grid item xs={5}>
              <InputField
                inputName={'percentage'}
                inputType={'text'}
                width={160}
                disabled={!checkedPercentage}
                maximumHeight={120}
              />
            </Grid>
            <Grid item xs={3}>
              <Toggle size="small" checked={checkedPercentage} onChange={handleCheckToggles} />
            </Grid>
          </Grid>
          <Grid item xs={12} display={'flex'} alignItems={'flex-start'} justifyContent={'space-between'}>
            <Grid item xs={4} padding={1}>
              <Typography component="span">Amount: </Typography>
            </Grid>
            <Grid item xs={5}>
              <InputField
                inputName={'amount'}
                inputType={'text'}
                width={160}
                disabled={!checkedAmount}
                maximumHeight={120}
              />
            </Grid>
            <Grid item xs={3}>
              <Toggle size="small" checked={checkedAmount} onChange={handleCheckToggles} />
            </Grid>
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  )
}
